module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emiDate),
      expression: "emiDate"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('emiDate'),
    },
    attrs: {
      "type": "date",
      "name": "emiDate",
      "disabled-date": function (emiDate) { return emiDate >= new Date(); }
    },
    domProps: {
      "value": (_vm.emiDate)
    },
    on: {
      "change": _vm.loadAgentMember,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emiDate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "emiDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Branch"
    }
  }, [_vm._v("Branch")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "branch_id",
      "label": "name",
      "options": _vm.branches,
      "placeholder": "Select Branch"
    },
    on: {
      "input": function($event) {
        return _vm.getBranchWiseRecord(_vm.branch)
      }
    },
    model: {
      value: (_vm.branch),
      callback: function($$v) {
        _vm.branch = $$v
      },
      expression: "branch"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1), _vm._v(" "), (_vm.user.type == 'admin') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Designation"
    }
  }, [_vm._v("Designation")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "designation_id",
      "label": "name",
      "options": _vm.designations,
      "placeholder": "Select Designation"
    },
    on: {
      "input": _vm.getStaff
    },
    model: {
      value: (_vm.designation),
      callback: function($$v) {
        _vm.designation = $$v
      },
      expression: "designation"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.user.type == 'admin' || _vm.user.role_id == 5) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', [_c('label', {
    attrs: {
      "for": "Designation"
    }
  }, [_vm._v("Staff")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "staff_id",
      "label": "name",
      "options": _vm.staffs,
      "placeholder": "Select Staff"
    },
    on: {
      "input": _vm.getAgentMembersCollection
    },
    model: {
      value: (_vm.staff),
      callback: function($$v) {
        _vm.staff = $$v
      },
      expression: "staff"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.user.type == 'admin' || _vm.user.role_id == 5) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('br'), _vm._v(" "), (this.staff) ? _c('span', [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.printView
    }
  }, [_vm._v("Get Print")])]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [(_vm.canAccess('member-loan-plan-view-any')) ? _c('div', {
    staticClass: "info-box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n            Amt : " + _vm._s(_vm.totalAmt) + "\n            "), _c('div', {
    staticClass: "input-group pull-right input-group-sm",
    staticStyle: {
      "width": "210px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.applicationNo),
      expression: "applicationNo"
    }],
    staticClass: "form-control pull-right",
    attrs: {
      "type": "text",
      "name": "applicationNo",
      "placeholder": "Search by Loan Application No"
    },
    domProps: {
      "value": (_vm.applicationNo)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.loadAgentMember()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.applicationNo = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadAgentMember()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "input-group pull-right input-group-sm",
    staticStyle: {
      "width": "330px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.table_search),
      expression: "table_search"
    }],
    staticClass: "form-control pull-right",
    attrs: {
      "type": "text",
      "name": "table_search",
      "placeholder": "Search by Member Name, Code, Mobile"
    },
    domProps: {
      "value": (_vm.table_search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.loadAgentMember()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.table_search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadAgentMember()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-sm table-hover"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.rowsAgentMemberRecords), function(row, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s((index + 1)))]), _vm._v(" "), _c('td', [(row.member_loan_plan) ? _c('span', [_vm._v(_vm._s(row.member_loan_plan.applicationNo))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.member.name))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.member.code))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.member.mobile))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.type))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [(row.collection_center_id) ? _c('span', [_vm._v(_vm._s(row.collection_center.name) + " (" + _vm._s(row.collection_center.centerCode) + ")")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm._f("myDate")(row.emiDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.arrear))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.total))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [(row.status === 'sattle' && row.member_collection_pending.length < 1) ? _c('i', [_vm._v("Unpaid")]) : (row.status === 'sattle' && row.member_collection_pending.length > 0) ? _c('i', [_vm._v("Pending")]) : (row.status === 'partial' && row.member_collection_pending.length > 0) ? _c('i', [_vm._v("Pending")]) : _c('i', [_vm._v(_vm._s(row.status))])])])
  }), 0)])]), _vm._v(" "), (_vm.pagination.current_page > 0) ? _c('div', {
    staticClass: "box-footer clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("\n            Showing " + _vm._s(_vm.pagination.from) + " to " + _vm._s(_vm.pagination.to) + " of " + _vm._s(_vm.pagination.total) + " entries\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('ul', {
    staticClass: "pagination pagination-sm no-margin pull-right"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'first')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("«")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'prev')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Prev")])]), _vm._v(" "), (_vm.pagination.current_page > 3) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 2) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 1) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "active",
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page))])]), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 4)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 1))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 5)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 6)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 3))])]) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 3)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 2)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 1)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page))])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'next')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Next")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'last')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("»")])])])])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "printView"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(4), _vm._v(" "), _c('button', {
    staticClass: "float-right btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.printAgentCollectionList()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "printAgentCollectionList"
    }
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [(_vm.getCompanyRecord) ? _c('div', {
    staticClass: "card-body box-profile"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('td', [_c('strong', [_vm._v("Agent Detail")]), _vm._v(" "), _c('br'), _vm._v("Name - " + _vm._s(_vm.staff.name)), _c('br'), _vm._v(" \n                      Address: " + _vm._s(_vm.staff.address)), _c('br'), _vm._v("\n                      branch: " + _vm._s(_vm.branch.name) + "\n                    ")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.getCompanyRecord.companyName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Address : " + _vm._s(_vm.getCompanyRecord.address) + ", " + _vm._s(_vm.getCompanyRecord.city) + ", " + _vm._s(_vm.getCompanyRecord.state) + " - " + _vm._s(_vm.getCompanyRecord.pin) + "\n                      "), _c('br'), _vm._v(" Website - " + _vm._s(_vm.getCompanyRecord.url) + "\n                      ")])])])])]), _vm._v(" "), _c('hr', {
    attrs: {
      "width": "100%"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Customer EMI Records ")]), _vm._v(" "), _c('p', {
    staticClass: "text-right"
  }, [_c('strong', [_vm._v("Total Amount : " + _vm._s(_vm.totalAmt))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_vm._m(5), _vm._v(" "), (_vm.rowsAgentMemberRecords) ? _c('tbody', {
    staticStyle: {
      "border-width": "2px",
      "color": "black",
      "border-style": "solid"
    }
  }, _vm._l((_vm.rowsAgentMemberRecords), function(rowsAgentMemberRecord, index) {
    return _c('tr', {
      key: rowsAgentMemberRecord.id,
      staticStyle: {
        "border-width": "2px",
        "border-style": "solid"
      }
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [(rowsAgentMemberRecord.member) ? _c('span', [_vm._v(_vm._s(rowsAgentMemberRecord.member.name))]) : _vm._e()]), _vm._v(" "), _c('td', [(rowsAgentMemberRecord.member) ? _c('span', [_vm._v(_vm._s(rowsAgentMemberRecord.member.mobile))]) : _vm._e()]), _vm._v(" "), _c('td', [(rowsAgentMemberRecord.member_loan_plan) ? _c('span', [_vm._v(_vm._s(rowsAgentMemberRecord.member_loan_plan.applicationNo))]) : _vm._e()]), _vm._v(" "), _c('td', [(rowsAgentMemberRecord) ? _c('span', [_vm._v(_vm._s(_vm._f("myDate")(rowsAgentMemberRecord.emiDate)))]) : _vm._e()]), _vm._v(" "), _c('td', [(rowsAgentMemberRecord) ? _c('span', [_vm._v(_vm._s(rowsAgentMemberRecord.arrear))]) : _vm._e()]), _vm._v(" "), _c('td', [(rowsAgentMemberRecord) ? _c('span', [_vm._v(_vm._s(rowsAgentMemberRecord.total))]) : _vm._e()]), _vm._v(" "), _c('td')])
  }), 0) : _vm._e()])])]) : _vm._e()])]), _vm._v(" "), _vm._m(6)])])]), _vm._v(" "), _c('payreceiptview', {
    attrs: {
      "seeRecord": _vm.payReceipt,
      "getCompanyRecord": _vm.getCompanyRecord
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Date "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Member Due EMIs")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "background-color": "#d6dddd"
    }
  }, [_c('tr', [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Sr. No.")]), _vm._v(" "), _c('th', [_vm._v("LoanID ")]), _vm._v(" "), _c('th', [_vm._v("Mem Name ")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Mem Code ")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Mobile")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Collection Center")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("EMI Date")]), _vm._v(" "), _c('th', [_vm._v("Dues")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("EMI")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Status")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("Sr No.")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Member")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Mob No")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Loan No")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("EMI Date")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Curr Due")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("EMI")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Collect Amt")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            CLOSE\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-04cd1c58!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/Reports/DueEmiReports.vue
// module id = 805
// module chunks = 0